/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_SubtitleInputs */

const cs_pm_subtitle = /** @type {(inputs: Pm_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spáruje inzeráty na portálu s nemovitostmi v CRM a uloží jejich ID.`)
};

const en_pm_subtitle = /** @type {(inputs: Pm_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pairs portal listings with CRM properties and saves their IDs.`)
};

/**
* | output |
* | --- |
* | "Pairs portal listings with CRM properties and saves their IDs." |
*
* @param {Pm_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_subtitle = /** @type {((inputs?: Pm_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_subtitle(inputs)
	return cs_pm_subtitle(inputs)
});